import { createClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';

import { sanityDataset, sanityProjectId, useCdn } from './constants';

export const sanityClient = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: '2025-09-09',
  useCdn: useCdn,
});

export {
  loyaltyHomepageConfigWebQuery,
  loyaltyHomepageConfigAppQuery,
} from './queries/loyalty-homepage-config';

export { nativeHomepageHeroQuery } from './queries/native-homepage-hero';

export const imageUrlBuilder = createImageUrlBuilder(sanityClient);

export type * from '../sanity.types';
